module.exports = __webpack_public_path__ + "main/assets/public/player/no-duration-line.9974ddce9d3b551e.svg";